<template>
    <div
        v-if="hintText"
        class="answer-hint">
        После {{ totalHints }} неверных ответов будет дана подсказка. Осталось {{remainedTry}} попытки из {{ totalHints }}.
    </div>
        <!-- После трех неверных ответов будет дана подсказка. Осталось {{remainedTry}} попытки из 3-х. -->
        
</template>

<script>
export default {
    name: 'AnswerHint',
    props: {
      numberTry: Number,
      totalHints: Number,
      hintText: String
    },
    computed:{
        remainedTry(){
            return this.totalHints - this.numberTry
        }        
    }
}
</script>

<style>
    
</style>